import { useRouter } from './Hooks';
import PropTypes from 'prop-types';

const RouteNotFoundProps = {
	render: PropTypes.element.isRequired,
};

export const RouteNotFound = ({ render }) => {
	const {
		state: { matched, isNoMatched },
	} = useRouter();

	return !matched && isNoMatched ? render : null;
};

RouteNotFound.propTypes = RouteNotFoundProps;
